import {createColumn, defaultColumns, fileField, inputTextField, relationField} from '../_defaults/columns'

export const columns = [
  fileField({
    label: 'Image',
    req: false,
    visible: false,
    field: 'imageUrl',
    section: 'Basics',
    mediaCollection: 'sponsorshipmedia',
    description: 'Images are constrained to a maximum of 200 pixels high and wide. We recommend cropping them before upload.'
  }),
  createColumn({
    label: 'Link URL',
    field: 'url',
    section: 'General',
    component: inputTextField({ req: false, max: 255, type: 'url' }),
    description: 'URLs should contain HTTP or HTTPS.  Example: www.google.com is not a link.  https://www.google.com is.'
  }),
  createColumn({
    label: 'Sponsorship Title',
    field: 'sponsorshipTitle',
    section: 'Associated SponsorshipTitle',
    // description: 'Listing of all users who have access to modify this school'
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'sponsorshipTitleId',
      // fk: 'id',
      namespace: 'sponsorshipTitle',
      filterIs: 'text-filter',
      label: 'name'
    })
  }),
  createColumn({
    label: 'Sort Order',
    field: 'sortOrder',
    type: 'number',
    defaultValue: '0',
    component: inputTextField({ req: true, type: 'number' }),
    description: 'Numeric value that indicates from top to bottom the order of Sponsorhip Titles.  Lower numbers on top.'
  })
].concat(defaultColumns)
